import { router, useLocalSearchParams } from 'expo-router';
import { useState } from 'react';

import { useCreateVolunteerEvent, useEditVolunteerEvent } from '@/api/hooks/volunteerHooks';
import FormWrapper from '@/components/forms/FormWrapper';
import VolunteerEventForm from '@/components/forms/VolunteerEventForm';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { VolunteerEventData } from '@/lib/validations/VolunteersSchema';
import { i18n } from '@/utils/i18n';
import { FileToUpload, uploadMultipleToFireStorage } from '@/utils/uploadMultipleToFireStorage';

const VolunteerEvent = () => {
  const { npoId } = useLocalSearchParams<{ npoId: string }>();

  const { mutateAsync: createVolunteerEvent, isPending } = useCreateVolunteerEvent();
  // Edit needed to upload files after volunteer event created to have ID
  const { mutateAsync: editvolunteerEvent, isPending: isEditingPending } = useEditVolunteerEvent();
  const { showSuccess, showError } = useEndFlowModal();

  const [fileProgress, setFileProgress] = useState<number | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: VolunteerEventData) => {
    try {
      setIsLoading(true);
      createVolunteerEvent(
        {
          name: data.name,
          subtitle: data.name,
          description: data.description,
          address: data.address,
          thumbnail: [],
          startDate: data.startDate?.toString(),
          location: data.location,
          nonProfitOrgId: npoId
        },
        {
          onSuccess: async (createResponse) => {
            let filesToUpload: FileToUpload[] = [];
            if (data.thumbnail) {
              data.thumbnail.map((thumb, index) => {
                if (thumb) {
                  filesToUpload.push({
                    uri: thumb,
                    name: `thumb_${index}.${new Date().toISOString()}`
                  });
                }
              });
            }

            if (filesToUpload.length > 0) {
              await uploadMultipleToFireStorage(
                `non-profits-orgs/${npoId}/volunteerEvent/${createResponse.id}/thumbs/`,
                filesToUpload,
                (_, progress) => {
                  setFileProgress(progress);
                }
              ).then((storagedFiles) => {
                const mappedFiles = storagedFiles.map((file) => file.metadata.fullPath);

                editvolunteerEvent(
                  {
                    volunteerId: createResponse.id,
                    body: {
                      thumbnail: mappedFiles
                    }
                  },
                  {
                    onSuccess: () => {
                      showSuccess({
                        title: i18n.t('profile.create_form.event_success_message'),
                        message: ''
                      });
                      router.back();
                    },
                    onError: (e) => {
                      console.error(e);
                      setIsLoading(false);
                    }
                  }
                );
              });
            } else {
              showError({
                title: i18n.t('profile.create_form.event_image_required_title'),
                message: i18n.t('profile.create_form.event_image_required_message')
              });
              router.back();
            }
          }
        }
      );
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  return (
    <FormWrapper>
      <VolunteerEventForm
        isLoading={isPending || isEditingPending || isLoading}
        fileProgress={fileProgress}
        onSubmitTapped={onSubmit}
      />
    </FormWrapper>
  );
};

export default VolunteerEvent;
